import Navbar from "../components/Navbar";
import ScrollToTop from "../components/ScrollToTop";
import { Outlet } from "react-router-dom";

const MainLayout = () => {
  return (
    <div className="app-root">
      <ScrollToTop />
      {/* <Navbar /> */}
      <Outlet />
    </div>
  );
};

export default MainLayout;
